<template>
  <div>
    <span>{{ headerValue }} </span>
    <FilterMenu
      v-if="!disabledEditMode"
      :col="headerValue"
      :show-filter="!!customViewRows"
      @showStateOfFilteredView="showStateOfFilteredView" />
    <SaveFilteredView
      v-if="saveFilteredView && customViewRows"
      :view="view" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import FilterMenu from './FilterMenu';
import SaveFilteredView from './SaveFilteredView';
export default {
  name: 'TableFilterTags',
  components: {
    FilterMenu,
    SaveFilteredView,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    header: {
      type: Object,
      default: null,
    },
    disabledEditMode: {
      type: Boolean,
      default: () => false,
    },
    isFreeWorkspace: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      view: null,
      saveFilteredView: false,
    };
  },
  computed: {
    ...mapState(['role']),
    ...mapState('ProjectDetailsTableSchedule', ['customViewRows']),
    headerValue() {
      return this.value || this.header?.value;
    },
  },
  methods: {
    showStateOfFilteredView(newView, state) {
      this.view = newView;
      this.saveFilteredView = state;
    },
  },
};
</script>
<style scoped lang="scss">
</style>
